import { z } from "zod";
import { Pathname } from "./pathname";

export const AssetNameSchema = Pathname.schema
  .refine(
    (value) => {
      const lowercased = value.toLowerCase();
      if (lowercased === "/api") {
        return false;
      }

      return !lowercased.startsWith("/api/");
    },
    {
      message: `/api is a reserved path and cannot be used as an asset name`,
    },
  )
  .transform((pathname) => {
    const parts = pathname.split("/");
    const lastPart = parts.pop();

    if (!lastPart) {
      parts.push("index.html");
    } else if (!lastPart.includes(".")) {
      parts.push(`${lastPart}.html`);
    } else {
      parts.push(lastPart);
    }

    return parts.join("/");
  })
  .brand("AssetName");

export type AssetName = z.infer<typeof AssetNameSchema>;

export const AssetName = {
  schema: AssetNameSchema,
};
